import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=1d73f3bd&scoped=true"
import script from "./Purchase.vue?vue&type=script&lang=js"
export * from "./Purchase.vue?vue&type=script&lang=js"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=1d73f3bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73f3bd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartSheetEmpty: require('/home/luiz/Sistemas/loja/components/CartSheetEmpty.vue').default,PaymentCart: require('/home/luiz/Sistemas/loja/components/Payment/Cart.vue').default,PaymentFormAddressBuyer: require('/home/luiz/Sistemas/loja/components/Payment/Form/AddressBuyer.vue').default,PaymentFormTermosCondicoes: require('/home/luiz/Sistemas/loja/components/Payment/Form/TermosCondicoes.vue').default,PaymentFormMethodPayment: require('/home/luiz/Sistemas/loja/components/Payment/Form/MethodPayment.vue').default,PaymentFormRegisterBuyer: require('/home/luiz/Sistemas/loja/components/Payment/Form/RegisterBuyer.vue').default,PaymentTypePaymentPix: require('/home/luiz/Sistemas/loja/components/Payment/TypePayment/Pix.vue').default,PaymentTypePaymentBoleto: require('/home/luiz/Sistemas/loja/components/Payment/TypePayment/Boleto.vue').default,PaymentOrderSummary: require('/home/luiz/Sistemas/loja/components/Payment/OrderSummary.vue').default,PaymentPaymentCardFormCard: require('/home/luiz/Sistemas/loja/components/Payment/PaymentCard/FormCard.vue').default})
